import('./init.tsx');
import('./polyfills');
